<template>
  <div class="input-root" ref="input-root" :style="getRootStyle">
    <div class="input-box">
      <v-date-picker 
        v-if="type==='date'"
        v-model.trim="inputfield"
        :disabled="disabled"
        :select-attribute="attrs"
        :masks="masks"
        is-required
      >
        <template v-slot="{ inputValue, inputEvents }">
            <input
              :class="[
                'form-control',
                'textbox-style',
                { 'form-control-with-icon': icon ? true : false },
                { invalidInput: is_invalid ? true : false },
              ]"
              :disabled="disabled"
              :ref="cus_ref"
              :value="inputValue.toUpperCase()"
              v-on="inputEvents"
              :readOnly="readOnly"
            />
            <label
              for=""
              class="form-label"
              v-if="type === 'date'"
              >{{ label }}</label
            >
        </template>
      </v-date-picker>
      <input
        v-if="type === 'text' || type === 'password' || type=== 'email'"
        :class="[
          'form-control',
          {'textbox-style': enableTextboxStyle===void 0?true:enableTextboxStyle },
          { 'form-control-with-icon': icon ? true : false },
          { invalidInput: is_invalid ? true : false },
        ]"
        :type="type"
        :label="label"
        :disabled="disabled"
        :ref="cus_ref"
        :placeholder="label"
        @keyup.enter="onEnter"
        v-model.trim="inputfield"
        v-on:focus="onFocus"
        v-on:blur="onBlur"
        :style="cus_style"
        :readOnly="readOnly"
      />
      <div
        v-if="type === 'search'" 
        class="search-box"
        @click="onFocus"
        v-click-outside="onBlur"
      >
        <button @click="click" class="btn-search"><i class="las la-search"></i></button>
        <input 
          type="text"
          class="input-search"
          :label="label"
          :disabled="disabled"
          :ref="cus_ref"
          :placeholder="label"
          @keyup.enter="onEnter"
          v-model.trim="inputfield"
          v-on:focus="onFocus"
          v-on:blur="onBlur"
          :style="cus_style"
          :readOnly="readOnly"
        >
      </div>
      <input
        v-if="type === 'otp'"
        :class="[
          'form-control-otp',
        ]"
        :type="type"
        :disabled="disabled"
        :ref="cus_ref"
        @keyup.enter="onEnter"
        v-model.trim="inputfield"
        v-on:focus="onFocus"
        v-on:blur="onBlur"
        :style="cus_style"
        :readOnly="readOnly"
      />
      <input
        v-if="type === 'no-label'"
        :class="[
          'form-control-no-label',
        ]"
        :type="type"
        :disabled="disabled"
        :placeholder="label"
        :ref="cus_ref"
        @keyup.enter="onEnter"
        v-model.trim="inputfield"
        v-on:focus="onFocus"
        v-on:blur="onBlur"
        :style="cus_style"
        :readOnly="readOnly"
      />
      <label
        for=""
        class="form-label"
        v-if="type === 'text' || type === 'password' || type === 'email'"
        >{{ label }}</label
      >
      <input
        v-if="type === 'number' && visible === true"
        :class="[
          'form-control',
          'number-style',
          { 'form-control-with-icon': icon ? true : false },
          { invalidInput: is_invalid ? true : false },
          'text-format',
        ]"
        type="number"
        :label="label"
        :disabled="disabled"
        :ref="cus_ref"
        :placeholder="label"
        v-model.trim="inputfield"
        min="0"
        step="0.05"
        @blur="onBlurNumber"
        @keyup.enter="onEnform - controlter"
        :style="cus_style"
        :readonly="readOnly"
      />
      <input
        v-if="type === 'number' && visible === false"
        :class="[
          'form-control',
          'number-style',
          { 'form-control-with-icon': icon ? true : false },
          { invalidInput: is_invalid ? true : false },
          'text-format',
        ]"
        type="text"
        :disabled="disabled"
        :ref="cus_ref"
        :placeholder="label"
        v-model.trim="inputfield"
        @focus="onFocusText"
        :style="cus_style"
        :readonly="readOnly"
      />
      <label
        for=""
        class="number-label"
        v-if="type === 'number' && type !== 'file'"
        >{{ label }}</label
      >
      <div class="form-input-icon" v-if="icon">
        <img :src="`/images/${icon}`" :alt="icon" />
      </div>

      <slot name="prefix"></slot>
      <slot name="post"></slot>

      <div v-if="type === 'file'" style="position: relative">
        <input
          :class="['form-control', { invalidInput: is_invalid ? true : false }]"
          :disabled="disabled"
          :ref="cus_ref"
          :placeholder="label"
          :value="label"
          style="cursor: pointer; padding: 8px !important"
          :style="cus_style"
          :readonly="true"
          @click.stop="selectFile"
        />
        <input
          style="display: none"
          type="file"
          ref="select-file-input"
          @change="fileChange"
        />
        <div style="position: absolute; top: 4px; right: 4px">
          <base-button
            type="button"
            stylevariant="primary"
            :cus_style="uploadFileButtonStyle"
            @click="selectFile"
          >
            Upload File
          </base-button>
        </div>
      </div>

      <div v-if="type == 'image'">
        <div
          class="imagePreviewWrapper"
          :style="{ 'background-image': `url(${previewImage || previewImageProp || '/images/upload_image.png'})` }"
          @click.stop="selectImage">
        <i v-if="previewImage || previewImageProp" @click.stop="removeImage" class="las la-times-circle close-icon"></i>

        </div>
        <input
          hidden
          ref="imageInput"
          type="file"
          accept="image/*"
          @input="pickImage">
      </div>
    </div>
    <div class="helper_text" :style="helper_text_Style" v-if="helper_text">
      {{ helper_text }}
    </div>
  </div>
</template>

<script>
export default {
  emits: ["change-value"],
  props: [
    "type",
    "label",
    "disabled",
    "placeholder",
    "is_invalid",
    "helper_text",
    "helper_text_Style",
    "field",
    "value",
    "cus_style",
    "remove_default_margin",
    "readOnly",
    "icon",
    "icon_position",
    "cus_ref",
    "input_info_class",
    "input_info_text",
    "enableTextboxStyle",
    "previewImageProp"
  ],
  data() {
    return {
      previewImage: null,
      inputfield: this.value,
      visible: true,
      temp: null,
      uploadFileButtonStyle: `color:#111111;background-color:#EAEAEA;border:none;border-radius:10px;font-size: 15px; font-family: Quicksand-Bold;height:35px;padding:5px 10px;`,
      masks: {
        input: 'DD-MMM-YYYY',
      },
      attrs: {
        highlight:{
          start: { 
            style: {
              backgroundColor: '#0059BE',
            },
            contentStyle: {
              color: '#ffffff',
            },
          },
        }
      }
    };
  },
  methods: {
    click() {
      if (this.inputfield) {
        this.$emit("click", this.inputfield);
      }
    },
    selectFile() {
      this.$refs["select-file-input"].click();
    },
    fileChange(e) {
      this.$emit("change-value", e.target.files[0], this.field);
    },
    onEnter(evt) {
      this.$emit("onEnter", this.inputfield);
      evt.target.blur();
    },
    onBlurNumber() {
      this.visible = false;
      this.temp = this.inputfield;
      this.inputfield = this.thousandSep(this.inputfield);
    },
    onFocusText() {
      this.visible = true;
      this.inputfield = this.temp;
    },
    thousandSep(amt) {
      if (
        amt !== "" ||
        amt !== undefined ||
        amt !== 0 ||
        amt !== "0" ||
        amt !== null
      ) {
        return amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return amt;
      }
    },
    onFocus() {
      this.$emit("onFocus", this.inputfield);
    },
    onBlur() {
      this.$emit("onBlur", this.inputfield);
    },
    selectImage () {
      this.$refs.imageInput.click();
    },
    pickImage () {
      let input = this.$refs.imageInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader;
        reader.onload = e => {
          this.previewImage = e.target.result;
          this.$emit('pickImage', this.previewImage, 'image');
        };
        reader.readAsDataURL(file[0]);
      }
    },
    removeImage() {
      this.previewImage = null;
      this.$refs.imageInput.files = null;
      this.$emit('removeImage');
    }
  },
  watch: {
    value: function (val) {
      this.inputfield = val;
    },
    inputfield() {
      if (this.visible === true)
        this.$emit("change-value", this.inputfield, this.field);
    },
  },
  computed: {
    getRootStyle() {
      return `margin-bottom: ${this.remove_default_margin ? "0px" : "20px"};
              `;
    },
  },
};
</script>

<style scoped lang="scss">
@import './BaseInput.scss';
</style>
